export const CallPartialProperties = {
  ENDPOINT_PRODUCT_NAME: '0261',
  ENDPOINT_PRODUCT_VERSION: '0262',
  SORENSON_SIP_VERSION: '0263',
  CARRY_OVER_TYPE: '0035',
  ENDPOINT_MAC_ADDRESS: '0018',
  CARRY_OVER_PHONE_NUMBER: '0019',
  CORE_SERVICES_USER_ID: '0025',
  CORE_RING_GROUP_OWNER_USER_ID: '0039',
  RING_GROUP_LOCAL_PHONE_NUMBER: '0037',
  RING_GROUP_TOLL_FREE_PHONE_NUMBER: '0038',
  IS_VCO_REQUESTED: '0036',
  DEAF_IP_TRACEBACK: '0008',
  DEAF_LOCAL_PHONE_NUMBER: '0027',
};

export const CallPartialKeys = {
  [CallPartialProperties.ENDPOINT_PRODUCT_NAME]: 'EndpointProductName',
  [CallPartialProperties.ENDPOINT_PRODUCT_VERSION]: 'EndpointProductVersion',
  [CallPartialProperties.CARRY_OVER_TYPE]: 'CarryOverType',
  [CallPartialProperties.ENDPOINT_MAC_ADDRESS]: 'EndpointMacAddress',
  [CallPartialProperties.CARRY_OVER_PHONE_NUMBER]: 'CarryOverPhoneNumber',
  [CallPartialProperties.CORE_SERVICES_USER_ID]: 'CoreServicesUserId',
  [CallPartialProperties.CORE_RING_GROUP_OWNER_USER_ID]:
    'CoreRingGroupOwnerUserId',
  [CallPartialProperties.RING_GROUP_LOCAL_PHONE_NUMBER]:
    'RingGroupLocalPhoneNumber',
  [CallPartialProperties.RING_GROUP_TOLL_FREE_PHONE_NUMBER]:
    'RingGroupTollFreePhoneNumber',
  [CallPartialProperties.IS_VCO_REQUESTED]: 'IsVcoRequested',
  [CallPartialProperties.DEAF_IP_TRACEBACK]: 'DeafIpTraceback',
  [CallPartialProperties.DEAF_LOCAL_PHONE_NUMBER]: 'DeafLocalPhoneNumber',
};
